import { render, staticRenderFns } from "./SmeltingEquipParaList.vue?vue&type=template&id=387b5fa7&"
import script from "./SmeltingEquipParaList.vue?vue&type=script&lang=js&"
export * from "./SmeltingEquipParaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports